/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCompanyControllerFindByGeocodeParamsGen,
  MrfiktivCompanyControllerGetParamsGen,
  MrfiktivCompanyGeoSearchResultViewModelGen,
  MrfiktivCompanyMatchViewModelGen,
  MrfiktivCompanyViewModelGen,
  MrfiktivCreateCompanyDtoGen,
  MrfiktivDuplicateCompanyTaxnumberViewModelGen,
  MrfiktivMatchCompanyDtoGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRegenerateTaxnumberNormalizedResultViewModelGen,
  MrfiktivUpdateCompanyDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Company<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerCreate
   * @summary (Company - CREATE) Create a Company
   * @request POST:/partner/{partnerId}/company
   * @secure
   * @response `201` `MrfiktivCompanyViewModelGen` The created company
   */
  companyControllerCreate = (partnerId: string, data: MrfiktivCreateCompanyDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivCompanyViewModelGen, any>({
      path: `/partner/${partnerId}/company`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerGet
   * @summary (Company - READ) Get all companies
   * @request GET:/partner/{partnerId}/company
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivCompanyViewModelGen)[] })`
   */
  companyControllerGet = ({ partnerId, ...query }: MrfiktivCompanyControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivCompanyViewModelGen[] }, any>({
      path: `/partner/${partnerId}/company`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerGetMany
   * @summary (Company - READ) Get many companies
   * @request POST:/partner/{partnerId}/company/getByIds
   * @secure
   * @response `200` `(MrfiktivCompanyViewModelGen)[]` The company
   */
  companyControllerGetMany = (partnerId: string, data: MrfiktivMultipleIdsDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivCompanyViewModelGen[], any>({
      path: `/partner/${partnerId}/company/getByIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerMatch
   * @summary (Company - READ) Find the companies matching a party
   * @request POST:/partner/{partnerId}/company/match
   * @secure
   * @response `200` `(MrfiktivCompanyMatchViewModelGen)[]` The matching companies, best first
   */
  companyControllerMatch = (partnerId: string, data: MrfiktivMatchCompanyDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivCompanyMatchViewModelGen[], any>({
      path: `/partner/${partnerId}/company/match`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerFindByGeocode
   * @summary (Company - READ) Get companies by location
   * @request GET:/partner/{partnerId}/company/byLocation
   * @secure
   * @response `200` `MrfiktivCompanyGeoSearchResultViewModelGen` The found records
   */
  companyControllerFindByGeocode = (
    { partnerId, ...query }: MrfiktivCompanyControllerFindByGeocodeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivCompanyGeoSearchResultViewModelGen, any>({
      path: `/partner/${partnerId}/company/byLocation`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerGetDuplicateTaxnumbers
   * @summary (Company - READ) Get duplicate normalized tax numbers
   * @request GET:/partner/{partnerId}/company/duplicates
   * @secure
   * @response `200` `(MrfiktivDuplicateCompanyTaxnumberViewModelGen)[]` Duplicate normalized tax numbers
   */
  companyControllerGetDuplicateTaxnumbers = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDuplicateCompanyTaxnumberViewModelGen[], any>({
      path: `/partner/${partnerId}/company/duplicates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerRegenerateTaxnumberNormalized
   * @summary (Company - UPDATE) Regenerate normalized tax numbers for all companies of a partner
   * @request POST:/partner/{partnerId}/company/taxnumber/regenerate-normalized
   * @secure
   * @response `201` `MrfiktivRegenerateTaxnumberNormalizedResultViewModelGen` Counts of matched and modified documents
   */
  companyControllerRegenerateTaxnumberNormalized = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRegenerateTaxnumberNormalizedResultViewModelGen, any>({
      path: `/partner/${partnerId}/company/taxnumber/regenerate-normalized`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerGetOne
   * @summary (Company - READ) Get a company
   * @request GET:/partner/{partnerId}/company/{companyId}
   * @secure
   * @response `200` `MrfiktivCompanyViewModelGen` The company
   */
  companyControllerGetOne = (partnerId: string, companyId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivCompanyViewModelGen, any>({
      path: `/partner/${partnerId}/company/${companyId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerUpdate
   * @summary (Company - UPDATE) Updates a company
   * @request PATCH:/partner/{partnerId}/company/{companyId}
   * @secure
   * @response `201` `MrfiktivCompanyViewModelGen` The updated company
   */
  companyControllerUpdate = (
    partnerId: string,
    companyId: string,
    data: MrfiktivUpdateCompanyDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivCompanyViewModelGen, any>({
      path: `/partner/${partnerId}/company/${companyId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerDelete
   * @summary (Company - DELETE) Deletes a company
   * @request DELETE:/partner/{partnerId}/company/{companyId}
   * @secure
   * @response `200` `MrfiktivCompanyViewModelGen` The deleted company
   */
  companyControllerDelete = (partnerId: string, companyId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivCompanyViewModelGen, any>({
      path: `/partner/${partnerId}/company/${companyId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags company
   * @name CompanyControllerMarkIsPartner
   * @summary (Company - UPDATE) Marks a company as the partners company
   * @request PATCH:/partner/{partnerId}/company/{companyId}/isPartner
   * @secure
   * @response `201` `MrfiktivCompanyViewModelGen` The updated company
   */
  companyControllerMarkIsPartner = (partnerId: string, companyId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivCompanyViewModelGen, any>({
      path: `/partner/${partnerId}/company/${companyId}/isPartner`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
}
